module.exports = __webpack_public_path__ + "img/CS-UL-I-Profiles.82a1dc31.jpg";